import React from "react";
import './Link.css';


const Link08 = () => {
  return (
    <div className="links">
    <div className="container">
    <div className="column">
    <h3 className="perfect" style={{marginTop : "170px"}}>Daily Bar Operations(IBC)</h3>
    <br />
    </div>

    <div className="cardstart" style={{marginTop : "30px"}}>
     <div className="cardf">
      <div className="cardf-image-container">
        <img width="100%" height="100%" src="link7.png" alt="pic" />
      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardfffdescription"> <b>Step 1 :  </b> Adopt a First In First Out method when using your kegs. The kegs with an earlier date of manufacturing/date of expiry should be used first.</h5>
      </div>
    </div>

     <div className="carde" style={{ marginTop: "4%" }}>

  <div className="container" style={{marginTop: "2%"}} >
      <div className="row">
        <div className="col-md-6">
          <img  src="pic2.jpg" alt="piccs"  style={{maxWidth:"100%"}}/>
        </div>
        <div className="col-md-6">
        <img  src="pic22.jpg" alt="piccs" style={{maxWidth:"100%"}} />

        </div>
      </div>
   
  </div>
  <div className="carde-content">
    <h2 className="carde-title"></h2>
    <h5 className="carde-description"> <b>Step 2 :  </b>Check the servicing card for your chillers to see if they have missed servicing or not.(IBC:15 days, DDS:3 months)</h5>
   
  </div>
</div>
    
 
<div className="carde" style={{ marginTop: "4%" }}>

  <div className="container" style={{marginTop:"2%"}}>
      <div className="row">
        <div className="col-md-6">
          <img className="ime"  src="pic3.jpg" alt="picccs" style={{maxWidth:"100%"}} />
        </div>
        {/* <div className="col-md-6" >
          <video  controls poster="link35a.webp"  style={{maxWidth:"100%",minWidth:"96%"}}>
            <source className="vid" src="link35a.mp4" type="video/mp4" />
          </video>
        </div> */}
      </div>
   
  </div>
  <div className="carde-content">
    <h2 className="carde-title"></h2>
      <h5 className="carde-description" > <b>Step 3 :  </b>Check the gas cylinder meter to see if there is sufficient volume in the cylinder. The gas should not be in the red zone. Turn on the gas cylinder by turning anti-clockwise if you have yet to do so</h5>
  </div>
</div>
    
    <div className="cardd-content" style={{marginTop:"4%"}} >
              <h2 className="cardff-title">Step 4 : Connect the beer keg</h2>
              
              <div className="container" style={{marginTop:"2%"}}>
                <div className="row">
                    <div>
                  <video width="100%" height="100%" controls poster="link8.4.1.jpeg">
                    <source className="image"  src="link8.4.1.mp4" type="video/mp4" />
                  </video>
                </div>
                
                <div className="cardz-content" >
                  <h5 className="cardff-substep-title" >
                   <b> Step 4.1:</b> Connect the dispense head to the beer keg and turn it clockwise to lock it (You have to align the dispense COUPLER with the spearhead before being able to turn it to secure. Do not force the dispense coupler onto the spearhead as it can cause damage to either components)
                  </h5>
                </div>
              </div>
              <div className="row">
              <div >
               <video width="100%" height="100%" controls poster="link8.4.2.jpeg">
                    <source src="link8.4.2.mp4" type="video/mp4" />
                  </video>
                </div>
           
                <div className="cardz-content">
                  <h5 className="cardff-substep-title">
                 <b>   Step 4.2:</b> Engage the dispenser by squeezing the lever and pushing down
                  </h5>
                </div>
              </div>
              </div>
            </div>
        

    
          <div className="cardd-content" >
              <h2 className="cardff-title">Step 5 : Clean the beer tap</h2>
              
              <div className="container" style={{marginTop:"2%"}}>
                <div className="row" >
                    <div >
                  <video width="100%" height="100%" controls poster="link8.5.1.jpeg">
                    <source src="link8.5.1.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="cardz-content">
                 < h5 className="cardff-substep-title" style={{marginTop:"0"}}>
                   <b> Step 5.1: </b>Prepare a brush and a pail of water. Soak the brush into the water
                  </h5>
                </div>
              </div>
              <div className="row">
                <div >
                  <video width="100%" height="100%" controls poster="link8.5.2.jpeg">
                    <source src="link8.5.2.mp4" type="video/mp4" />
                  </video>
                </div>
                <div  className="cardz-content">
                  <h5 className="cardff-substep-title">
                   <b> Step 5.2: </b> Scrub the tap thoroughly with the brush
                  </h5>
                </div>
              </div>
              <div className="row">
                <div >
                  <video width="100%" height="100%" controls poster="link8.5.3.jpeg">
                    <source src="link8.5.3.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="cardz-content" >
                  <h5 className="cardff-substep-title">
                   <b> Step 5.3: </b> Turn on the tap to flush out any residue
                  </h5>
                </div>
              </div>
            </div>
         </div>

   <div className="cardf" style={{flexDirection:"column",alignItems:"center",marginTop:"4%"}}>
  <div className="cardf-content" >
    <h2 className="cardf-title">Step 6 :Ensure clean glassware</h2>
      <h5  className="cardf-description"></h5>
  </div>
  <div className="container" >
    <div className="row">
      <div className="col-md-6" style={{marginTop:"1%"}}>
        <img src="pic61.jpg" alt="pics" />
      </div>
      <div className="col-md-6" style={{marginTop:"1%"}}>
        <img src="pic62.jpg" alt="pics"   />
      </div>
    
    
      <div className="col-md-6" style={{marginTop:"1%"}}>
        <img src="pic63.jpg" alt="pics"  />
      </div>
      <div className="col-md-6" style={{marginTop:"1%"}}>
        <img src="pic64.jpg" alt="pics" />
      </div>
   </div>
  </div>
  <h5>Examples of glasses that are not clean</h5>
</div>         


  <div className="cardf">
      <div className="cardf-image-container">
        <img width="100%" height="100%" src="pic7.jpg" alt="pic" />
      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
      <h5 className="cardfffdescription"> <b>Step 7 :  </b>You should not continuously tap more than 3 * 30 litres kegs for a single chiller as this will cause the chiller to have insufficient time to chill the beer. If you have a secondary machine, alternate between the two machines for tapping</h5> 
      </div>
    </div>

    
      
    </div>
    </div>
    </div>

    )
}

export default Link08;
